import * as yup from 'yup';
import { AnyObject, Maybe, Message } from 'yup/lib/types';
import PhoneNumber from 'awesome-phonenumber';

declare module 'yup' {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType
  > extends yup.BaseSchema<TType, TContext, TOut> {
    phoneNumber(message?: string): StringSchema<TType, TContext>;
  }
}

const registerPhoneValidation = (): void =>
  yup.addMethod(
    yup.string,
    'phoneNumber',
    function phoneNumber(message: Message = '') {
      return this.test({
        name: 'phoneNumber',
        exclusive: true,
        message,
        test: (value?: string) =>
          // Note: using isPossible instead of isValid (https://github.com/catamphetamine/libphonenumber-js#using-phone-number-validation-feature)
          value ? new PhoneNumber(value).isPossible() : false,
      });
    }
  );

export default registerPhoneValidation;
